module.exports = __webpack_public_path__ + "82a7fb43220d2568b815676bb7a6d8bb.png";